/**
 * 申请税票
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, DatePicker, Select, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import TaxEdit from './TaxEdit';
import TaxPrint from './TaxPrint';
import TaxScrap from './TaxScrap';
//红冲
import TaxRedRush from './TaxRedRush';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import { stringAddOne } from '../../../util/util';
import Loading from '../../ui/Loading';
import OrgSelect from '../../ui/OrgSelect';
//加载参数
import paramUtil from '../../ui/paramUtil';
import TaxPayRefund from './TaxPayRefund';
import { global_data } from '../../ui/auth'

class TaxIndex extends React.Component {

    columns = [{
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '10%',
    }, {
        title: '交易价格',
        dataIndex: 'amount',
        width: '10%',
    }, {
        title: '税款金额',
        dataIndex: 'sellerTaxAmount',
        width: '9%',
        // render: (text, record, index) => {
        //     let t = (text == null ? '' : text) + (record.buyerTaxAmount == null || record.buyerTaxAmount === "" ? "" : ("/" + record.buyerTaxAmount));
        //     return (<Tooltip title={t}>
        //         <span>{t}</span>
        //     </Tooltip>);
        // }
    }, {
        title: '税款缴纳情况',
        dataIndex: 'sellerPayState',
        width: '11%',
        render: (text, record, index) => {
            let sellerPay = record.sellerPayState === 2 ? '已退款' : record.sellerPayState === 1 ? record.sellerPayAmount : '未支付';
            // let buyerPay = record.buyerPayState === 2 ? '已退款' : record.buyerPayState === 1 ? record.buyerPayAmount : '未支付';
            // let t = sellerPay + "/" + buyerPay;
            let t = sellerPay;
            return (<Tooltip title={t}>
                <span>{t}</span>
            </Tooltip>);
        }
    }, {
        title: '新车主',
        dataIndex: 'buyerName',
        width: '15%',
    }, {
        title: '旧车主',
        dataIndex: 'sellerName',
        width: '15%',
    }, {
        title: '旧车主类型',
        dataIndex: 'sellerType',
        width: '10%',
        format: { 1: "个人", 2: "小规模", 3: "一般纳税人", 4: "固定资产的一般纳税人" }
    }, {
        title: '税票号',
        dataIndex: 'sellerTaxNo',
        width: '10%',
        // render: (text, record, index) => {
        //     let t = (text == null ? '' : text) + (record.buyerTaxNo == null || record.buyerTaxNo === "" ? "" : ("/" + record.buyerTaxNo));
        //     return (<Tooltip title={t}>
        //         <span>{t}</span>
        //     </Tooltip>);
        // }
    }, {
        title: '交易票号',
        dataIndex: 'invoiceNo',
        width: '10%',
    }, {
        title: '开票时间',
        dataIndex: 'ticketTime',
        width: '15%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => {
            let dom = "";
            dom = (
                <div>
                    {global_data.authCode.includes("TAX_TICKET_UPDATE")&&record.state !== 2 ?
                        <Tooltip title="修改">
                            <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                        </Tooltip>
                        : ''}
                    {
                        // eslint-disable-next-line eqeqeq
                        global_data.authCode.includes("TAX_TICKET_PRINT")&&record.invoiceNo != null && record.sellerType == 1 ?
                            <Tooltip title="打印">
                                <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.print.bind(this, record)} />
                            </Tooltip>
                            : ""}
                    {global_data.authCode.includes("TAX_TICKET_REFUND")&&(record.sellerPayState === 1 || record.buyerPayState === 1) ?
                        <Tooltip title="退款">
                            <Icon type="pay-circle" theme="filled" className="table-operate-icon" onClick={this.doRefund.bind(this, record)} />
                        </Tooltip>
                        : ""}
                </div>
            )
            return dom;
        }
    }];

    state = {
        visible: false,
        detailVisible: false,
        editData: {},
        loadData: '',
        queryData: {},
        showLoding: false,

        scrapVisible: false,

        taxFiller: '',
        taxAuthorities: '',

        redRushVisible: false,

        refundVisible: false,
        taxPayList: []
    };

    componentDidMount() {
        paramUtil.memberParam(
            { code: 'tax_filler' },
            (res) => {
                this.setState({ taxFiller: res });
            }
        );
        paramUtil.memberParam(
            { code: 'tax_authorities' },
            (res) => {
                this.setState({ taxAuthorities: res });
            }
        );
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    showModalDetail = () => {
        this.setState({ detailVisible: true });
    };
    hiddenModalDetail = () => {
        this.setState({ detailVisible: false });
    };
    update = (info, e) => {
        if (info.filler === undefined || info.filler == null || info.filler === "") {
            info.filler = this.state.taxFiller;
        }
        if (info.taxAuthorities === undefined || info.taxAuthorities == null || info.taxAuthorities === "") {
            //info.taxAuthorities = "湖里国税";
            info.taxAuthorities = this.state.taxAuthorities;
        }
        info.buyerType = info.buyerType + "";
        info.sellerType = info.sellerType + "";
        this.setState({ editData: info });
        this.showModal();
        this.ref.initCalculation(info);
    }
    print = (info, e) => {
        //this.setState({ editData: info });
        if (info.filler === undefined || info.filler == null || info.filler === "") {
            info.filler = this.state.taxFiller;
        }
        if (info.taxAuthorities === undefined || info.taxAuthorities == null || info.taxAuthorities === "") {
            // info.taxAuthorities = "湖里国税";
            info.taxAuthorities = this.state.taxAuthorities;
        }
        info.buyerType = info.buyerType + "";
        info.sellerType = info.sellerType + "";
        info.sellerTaxNoTemp = info.sellerTaxNo;
        info.buyerTaxNoTemp = info.buyerTaxNo;
        if (info.sellerTaxNo == null || info.sellerTaxNo === "" || info.buyerTaxNo == null || info.buyerTaxNo === "") {
            http.post({
                url: '/taxTicket/getMaxTaxNo',
                data: {
                    orgCode: info["orgCode"]
                },
                success: (res) => {
                    if (info.sellerTaxNo == null || info.sellerTaxNo === "") {
                        let sellerTaxNo = stringAddOne(res);
                        res = sellerTaxNo;
                        info.sellerTaxNoTemp = sellerTaxNo;
                    }
                    if (info.buyerTaxNo == null || info.buyerTaxNo === "") {
                        info.buyerTaxNoTemp = stringAddOne(res);
                    }
                    this.printRef.initPrintData(info);
                    this.showModalDetail();
                }
            });
        } else {
            this.printRef.initPrintData(info);
            this.showModalDetail();
        }
    }

    doRefund = (info, e) => {
        http.get({
            url: '/taxTicket/findTaxPayOrder',
            data: {
                applicationId: info.applicationId
            },
            success: (res) => {
                if (res == null || res.length === 0) {
                    messager.notify("没有可进行退款的订单！");
                    return;
                }
                this.setState({ refundVisible: true, editData: info, taxPayList: res });
            }
        });
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.state = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    download = (downloadType) => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "" || queryData.endDate == null || queryData.endDate === "") {
            messager.notify("导出时需选择时间段！", null, "warning");
            return;
        }
        this.setState({ showLoding: true });
        let fileName = queryData.startDate + "~" + queryData.endDate + "tax-ticket-detail.xlsx";
        if (downloadType === 2) {
            fileName = queryData.startDate + "~" + queryData.endDate + "tax-ticket-special.xlsx";
        } else if (downloadType === 3) {
            //用来核对开票情况的
            fileName = queryData.startDate + "~" + queryData.endDate + "tax-ticket.xlsx";
        }
        queryData.downloadType = downloadType;
        http.download({
            url: '/taxTicket/downloadTaxTicket',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ showLoding: false });
            }
        });
        messager.notify("只会根据查询的时间段、票据类型和市场导出已经打印的数据！");
    }

    onRef = (ref) => {
        this.ref = ref
    }
    onPrintRef = (ref) => {
        this.printRef = ref;
    }

    scrapTaxTicket = () => {
        this.setState({ scrapVisible: true });
    }

    hiddenModalScrap = () => {
        this.setState({ scrapVisible: false });
    }

    //税票红冲
    showModalRedRush = () => {
        this.setState({ redRushVisible: true });
    }

    //隐藏税票红冲
    hiddenModalRedRush = () => {
        this.setState({ redRushVisible: false });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch.bind(this, "queryString")}
                                    enterButton
                                    style={{ width: 200 }}
                                />
                                <Input.Search
                                    placeholder="税票号"
                                    onSearch={this.inputSearch.bind(this, "taxNo")}
                                    enterButton
                                    style={{ width: 130, marginLeft: '10px' }}
                                />
                                <Select defaultValue="" style={{ width: 80, marginLeft: '10px', marginRight: '10px' }} onChange={this.selectChange}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="0">未打印</Select.Option>
                                    <Select.Option value="1">已打印</Select.Option>
                                    <Select.Option value="2">已作废</Select.Option>
                                    <Select.Option value="3">自带票</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <OrgSelect style={{ width: '150px', marginLeft: '10px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                                <Button type="primary" onClick={this.download.bind(this, 3)} style={{ marginLeft: '20px', "float": "right" }}>核对</Button>
                                {global_data.authCode.includes("TAX_TICKET_RED")?
                                <Button type="primary" onClick={this.showModalRedRush} style={{ "float": "right" }}>红冲</Button>
                                :""}
                                {global_data.authCode.includes("TAX_TICKET_CANCEL")?
                                <Button type="primary" onClick={this.scrapTaxTicket} style={{ margin: '0 20px', "float": "right" }}>作废</Button>
                                :""}
                                <Button type="primary" onClick={this.download.bind(this, 2)} style={{ marginLeft: '20px', "float": "right" }}>导出2</Button>
                                <Button type="primary" onClick={this.download.bind(this, 1)} style={{ "float": "right" }}>导出1</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/taxTicket/findTaxTicketPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <TaxEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    onRef={this.onRef}
                />
                <TaxScrap
                    visible={this.state.scrapVisible}
                    onCancel={this.hiddenModalScrap.bind(this)}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <TaxPrint
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenModalDetail.bind(this)}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    onRef={this.onPrintRef}
                />
                <TaxRedRush
                    visible={this.state.redRushVisible}
                    onCancel={this.hiddenModalRedRush.bind(this)}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <TaxPayRefund
                    visible={this.state.refundVisible}
                    onCancel={() => this.setState({ refundVisible: false })}
                    data={this.state.editData}
                    list={this.state.taxPayList}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.showLoding} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default TaxIndex;